import ajax from '../utils/ajax';
import {loader} from './loader';
import {showModalNotification} from '../common/modal-notification';
import messages from '../messages/common';

const message = messages();

/**
 * Collect data from the form
 * @param form
 * @param data
 * @returns {FormData}
 */
let getData = (form, data) => {
    const formData = new FormData($(form)[0]);

    if (Object.keys(data).length) {
        for (let key in data) {
            if (key === 'files[]') {
                for (let index in data['files[]']) {
                    if (Object.prototype.hasOwnProperty.call(data['files[]'], index)) {
                        formData.append('files[]', data['files[]'][index]);
                    }
                }
            } else if (Object.prototype.hasOwnProperty.call(data, key)) {
                if ($.isArray(data[key])) {
                    for (let i = 0; i < data[key].length; i++) {
                        if ($.isPlainObject(data[key][i])) {
                            Object.keys(data[key][i]).forEach((keyObj) => {
                                formData.append(`${key}[${i}][${keyObj}]`, data[key][i][keyObj]);
                            }, data[key][i]);
                        } else {
                            formData.append(`${key}[]`, data[key][i]);
                        }
                    }
                } else {
                    formData.append(key, data[key]);
                }
            }
        }
    }

    return formData;
};

/**
 * Sender data
 * @param form
 * @param data
 * @returns {Promise<T>}
 */
let sender = (form, data = {}) => {
    const url = $(form).attr('action');

    const formData = getData(form, data);

    loader(true);

    return ajax({
        url,
        type: 'POST',
        data: formData,
        dataType: 'json',
        cache: false,
        contentType: false,
        processData: false,
    }).catch(() => {
        showModalNotification({
            title: message.textError,
            body: message.textRequestError,
        });
    }).finally(() => {
        loader(false);
    });
};

export {sender as submitHandler};
